import { render, staticRenderFns } from "./ModalTeamIncidentAssign.vue?vue&type=template&id=397ea29d&"
import script from "./ModalTeamIncidentAssign.vue?vue&type=script&lang=js&"
export * from "./ModalTeamIncidentAssign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports